import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import { useEffect } from 'react'
import { usePartnerContext, useUserContext } from '../../../context'
import { useLifecycleStageTracking } from '../../../hooks/useLifecycleStageTracking'
import AssistantDrawer from '../components/AssistantDrawer'
import DiscoverPageLayout from '../components/DiscoverPageLayout'
import StartOptionsSection from '../components/StartOptionsSection'
import WelcomeVideoModal from '../components/WelcomeVideoModal'
import { DiscoverContextProvider } from '../context/DiscoverContext'
import { getGreetingKeyByTime } from '../utils'

export default function IntroPage() {
  const { t } = useTranslation()
  const { activeSpace } = useUserContext()
  const { partner } = usePartnerContext()
  const { trackLifecycleStage } = useLifecycleStageTracking()
  const isDiscoverVisible = partner.isDashboardComponentVisible.discover
  const { firstname: username } = activeSpace.person

  if (!isDiscoverVisible) {
    return <Navigate to='/404' replace />
  }

  useEffect(() => {
    trackLifecycleStage({
      aivy_form_id: partner.aivy_form_id,
      partner_id: partner.id,
      updateOnlyPartnerId: true
    })
  }, [])

  const greetingKey = getGreetingKeyByTime()
  const hasCompletedOnboarding = activeSpace?.hasCompletedOnboarding

  return (
    <DiscoverContextProvider>
      {/* <RegistrationAssistantHandler /> */}
      <DiscoverPageLayout>
        {/* <DiscoverHeroSection
          title={t(`discover.discover_hero_section.greeting.${greetingKey}`, {
            username: username || '#HeRo'
          })}
          headline={t('discover.discover_hero_section.headline')}
          subline={t('discover.discover_hero_section.intro.subline')}
          // steps={steps}
        /> */}
        <StartOptionsSection />
        <AssistantDrawer />
        {!hasCompletedOnboarding && <WelcomeVideoModal />}
      </DiscoverPageLayout>
    </DiscoverContextProvider>
  )
}
